<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div class="relative">

  <div class="vx-top-navbar-wrapper" :class="classObj">
    <vs-navbar class="vx-navbar vs-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
      <div class=" vs-con-items justify-between">
        <div class="text-center" style="float:center; vertical-align:middle;" @click.stop="activeSidebar=!activeSidebar">
          <!-- <transition-group name="fade" v-on:after-enter="fadeNext" @click="toggleOff()">
            <disc-icon v-if="isStatusOff" v-show="isStatusOff == true" key="0" size="1.5x" class="custom-class" style="vertical-align:middle;" @click="toggleOff()"></disc-icon>
            <x-icon v-if="isStatusOff == false" v-show="isStatusOff == false" key="1" size="1.5x" style="vertical-align:middle;" class="custom-class" @click="toggleOff()"></x-icon>
          </transition-group> -->
          <span style="font-size:18px;" class="cursor-pointer">문제 리스트</span>
        </div>
        <div class="cursor-pointer" @click="main()">
          <home-icon size="1.0x" class="custom-class" style="margin-right:5px;"></home-icon>
          <span  style="font-size:18px;">{{activeSubject.subject}}</span>
        </div>
        <div>
          <!-- <span style="color:#1d9cd3;"> 60:00</span> -->
          <vs-button v-if="$route.path == '/app/exam/form'" class="cursor-pointer" color="primary" style="olor:#1d9cd3;" type="border" icon-pack="feather" size="small" icon="icon-plus" @click="createQuestion()">문제 생성</vs-button>
        </div>
      </div>
    </vs-navbar>
  </div>
  <div id="theme-customizer">
    <!-- Open Customizer Button -->
    <!-- Customizer Content -->
    <vs-sidebar hidden-background v-model="activeSidebar" class="items-no-padding">
      <div class="h-full">
        <div class="customizer-header mt-6 flex items-center justify-between px-6" @click="clickXIcon()">
          <div>
            <h4>문제 리스트</h4>
            <!-- <small>Customize & Preview in Real Time</small> -->
          </div>
          <feather-icon icon="XIcon" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider />
        <!-- <vs-divider class="mb-0" /> -->
        <component :is="scrollbarTag" class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
          <exam-number v-for="(question, index) in questionList" :data="question" :key="index" @close="activeSidebar =false" />
        </component>
      </div>
    </vs-sidebar>
  </div>
</div>
</template>


<script>
// import './hamburger.js'
import {
  DiscIcon
} from 'vue-feather-icons'
import {
  XIcon
} from 'vue-feather-icons'
import {
  HomeIcon
} from 'vue-feather-icons'

import ExamNumber from "./ExamNumber.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
let fadeIdx = 0

export default {
  name: "exam-top",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      activeSidebar: false,
      alarmFlag: true,
      testId: 'test12',
      isStatusOn: false,
      isStatusOff: true,
      fade: [false, false],
      ExamNumList: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .80,
      },
      questionInfo: {
        'id': 0,
        'index': 0,
        'exam_subject_id': 0,
        'title': '',
        'question_info': '',
        'question_type': 1,
        'answer': '',
        'score': 1,
        'answer_multiple': [],
        'answer_number': 0,
        'solving': '',
        'tags': [],
        'sequence':0,
        'audio_file_name':'',
        'ex_answer':''
      },
    }
  },
  components: {
    DiscIcon,
    XIcon,
    HomeIcon,
    ExamNumber,
    VuePerfectScrollbar,
  },
  computed: {
    activeSubject() {
      return this.$store.state.etest.activeSubject
    },
    questionList() {
      return this.$store.state.etest.questionList
    },
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor() {
      return {
        'text-white': (this.navbarColor != '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor != '#fff' && this.$store.state.theme !== 'dark')
      }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default") return "navbar-default"
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced"
      else if (this.verticalNavMenuWidth) return "navbar-full"
    },
    scrollbarTag() {
      return this.$store.state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
    },
  },
  // watch: {
  //   activeSidebar(){
  //     console.log(this.activeSidebar)
  //   }
  //   // '$route'() {
  //   //   if(this.$route.path.includes('alarm')){
  //   //     this.alarmFlag = false
  //   //   } else {
  //   //     this.alarmFlag = true
  //   //   }
  //   // },
  // },

  methods: {
    createQuestion() {
      this.questionInfo.exam_subject_id = this.activeSubject.id
      this.$store.dispatch('etest/createEtestQuestion', this.questionInfo).then((resolve) => {
        this.$store.commit('etest/ACTIVE_QUESTION', resolve)
        this.$vs.notify({
          color: 'success',
          title: this.questionList.length + '문제를 생성 했습니다.',
          text: '내용을 입력후 꼭 저장 버튼을 눌러 주세요.'
        })
      })
    },
    main() {
      this.$router.push('/apps/epractice')
    },
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    },
    toggleOff: function() {
      this.isStatusOff = !this.isStatusOff;
    },
    fadeNext: function() {
      this.fade.splice(fadeIdx++, 1, true)
    },
    clickXIcon() {
      if (this.activeSidebar) {
        this.activeSidebar = false
      }

    },
    showList() {
      if (!this.activeSidebar) {
        this.activeSidebar = true
      }
    }
  },
  mounted() {
    setTimeout(this.fadeNext, 1000)
  },
  watch: {
    '$route'(to) {
      if (to.path == '/app/practice/form') {
        this.typePath = false
      }else {
        this.typePath = true
      }
    }
  }
}
</script>

<style>
/* .test{
  transition: all .35s;
} */
.fade-bottom-enter-active,
.fade-bottom-leave-active {
  transition: opacity .3s, transform .35s;
}

.fade-bottom-enter {
  opacity: 0;
  transform: translateX(-8%);
}

.fade-bottom-leave-to {
  opacity: 0;
  transform: translateX(8%);
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity .5s;
}

;
</style>
